<template>
  <div class="assessment-container">
    <div class="assessment-list">
      <div
        v-for="(item, index) in displayedItems"
        :key="index"
        :class="['assessment-item', item.type]"
        @click="isMultiLine(item.text) && toggleItem(index)"
        :style="{ cursor: isMultiLine(item.text) ? 'pointer' : 'default' }"
      >
        <span
          class="iconfont-ai icon"
          :class="[
            'triangle-' + item.type,
            item.icon,
            isMultiLine(item.text) ? '' : 'disabled'
          ]"
        ></span>
        <span ref="textRefs" :class="['text', { expanded: item.expanded }]">{{
          item.text
        }}</span>
        <span
          v-if="isMultiLine(item.text)"
          :class="['arrow', { expanded: item.expanded }]"
        >
          <span class="iconfont-ai" :class="['triangle-' + item.type]"
            >&#xe76a;</span
          >
        </span>
        <span v-else class="arrow disabled">
          <span class="iconfont-ai" :class="['triangle-' + item.type]"
            >&#xe76a;</span
          >
        </span>
      </div>
    </div>
    <div v-if="items.length > 4" class="view-all" @click="toggleViewAll">
      {{ viewAllText }}
    </div>
  </div>
</template>

<script>
export default {
  name: "AutoReportTag",
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      showAll: false,
      textHeightMap: new Map(),
      itemTypeInfo: [
        {
          type: "neutral",
          prefix: "",
          icon: "icon-a-biaoqianzhuangtaitubiaozhongxing"
        },
        {
          type: "excellent",
          prefix: "优秀",
          icon: "icon-a-biaoqianzhuangtaitubiaoyouxiu"
        },
        {
          type: "warning",
          prefix: "缺点",
          icon: "icon-a-biaoqianzhuangtaitubiaoquedian"
        },
        {
          type: "suggestion",
          prefix: "建议",
          icon: "icon-a-biaoqianzhuangtaitubiaojianyi"
        },
        {
          type: "neutral",
          prefix: "中性",
          icon: "icon-a-biaoqianzhuangtaitubiaozhongxing"
        }
      ]
    };
  },
  computed: {
    handledItems() {
      return this.items.map(item => {
        return {
          type: `${this.itemTypeInfo[item.messageType]?.type}`,
          text: `${item.message}`,
          icon: `${this.itemTypeInfo[item.messageType]?.icon}`,
          expanded: false
        };
      });
    },
    assessmentItems() {
      return JSON.parse(JSON.stringify(this.handledItems));
    },
    displayedItems() {
      return this.showAll
        ? this.assessmentItems
        : this.assessmentItems.slice(0, 4);
    },
    viewAllText() {
      return this.showAll ? "点击收起" : "点击查看全部";
    }
  },
  methods: {
    toggleItem(index) {
      if (this.isMultiLine(this.assessmentItems[index].text)) {
        this.assessmentItems[index].expanded = !this.assessmentItems[index]
          .expanded;
      }
    },
    toggleViewAll() {
      this.showAll = !this.showAll;
    },
    isMultiLine(text) {
      if (this.textHeightMap.has(text)) {
        return this.textHeightMap.get(text);
      }

      const textElements = this.$refs.textRefs;
      if (!textElements) return false;

      const textElement = textElements.find(el => el.textContent === text);
      if (!textElement) return false;

      const isMultiple = textElement.scrollHeight > 21;
      this.textHeightMap.set(text, isMultiple);

      return isMultiple;
    }
  }
};
</script>

<style scoped>
.assessment-container {
  width: 100%;
  margin: 10px auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.title {
  font-size: 20px;
  margin-bottom: 15px;
  padding: 0 15px;
}

.assessment-list {
  background: #fff;
  overflow: hidden;
}

.assessment-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border: 1px solid #f0f0f0;
  border-radius: 5px;
  position: relative;
  transition: all 0.3s ease;
  margin-bottom: 10px;
}

.icon {
  margin-right: 5px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.excellent .icon {
  color: #4caf50;
}

.neutral .icon {
  color: #9e9e9e;
}

.suggestion .icon {
  color: #ff9800;
}

.warning .icon {
  color: #f44336;
}

.text {
  flex: 1;
  font-size: 14px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  transition: all 0.3s ease;
}

.text.expanded {
  -webkit-line-clamp: initial;
}

.arrow {
  color: #ccc;
  font-size: 18px;
  margin-left: 10px;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.arrow.expanded {
  transform: rotate(90deg);
}

.disabled {
  filter: opacity(0.5);
}

.view-all {
  text-align: center;
  padding: 15px;
  color: #000000;
  background: #f4f5f7;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border-radius: 5px;
}

.view-all:hover {
  background: #f4f5f7;
}

.excellent {
  border-color: #9fc95d;
  background: rgba(159, 201, 93, 0.2);
}

.neutral {
  border-color: #59abec;
  background: rgba(89, 171, 236, 0.2);
}

.suggestion {
  border-color: #eaa552;
  background: rgba(234, 165, 82, 0.2);
}

.warning {
  border-color: #cb3d3d;
  background: rgba(203, 61, 61, 0.2);
}

.triangle-excellent {
  color: #9fc95d;
}

.triangle-neutral {
  color: #59abec;
}

.triangle-suggestion {
  color: #eaa552;
}

.triangle-warning {
  color: #cb3d3d;
}
</style>
